import styled from 'styled-components';

export default function LiveSalesTotal({ total }: { total: number | null }) {
  return <SalesRow aria-label="전체 매출" title="취소 수량을 제외한 전체 상품 주문 금액">
    <span>전체 매출</span><strong>{total === null ? '—' : `${total.toLocaleString('ko-KR')}원`}</strong>
  </SalesRow>;
}

const SalesRow = styled.div`
  display: flex; align-items: center; justify-content: space-between; gap: var(--space-2);
  padding: var(--space-1) 0 var(--space-2); margin-top: var(--space-1);
  color: var(--color-text-primary); font-family: var(--font-family-base); font-size: var(--text-body);
  span { color: var(--color-text-secondary); }
  strong { font-size: var(--text-body-lg); font-weight: 600; font-variant-numeric: tabular-nums; white-space: nowrap; }
`;
